(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ee-fit-dialog"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const trigger=event.target.closest('[data-fit-guide]');if(!trigger)return;const dialog=document.querySelector('.ee-fit-dialog');if(!dialog||typeof dialog.showModal!=='function')return;event.preventDefault();dialog.eeReturnFocus=trigger;dialog.eePreviousOverflow=document.body.style.overflow;dialog.showModal();document.body.style.overflow='hidden';dialog.querySelector('[data-fit-close]').focus();});
document.querySelectorAll('.ee-fit-dialog').forEach(dialog=>{dialog.querySelector('[data-fit-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});dialog.addEventListener('close',()=>{document.body.style.overflow=dialog.eePreviousOverflow||'';dialog.eeReturnFocus?.focus();});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ee-haptics"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!('vibrate' in navigator)) return;
    function buzz(pattern) {
      try { navigator.vibrate(pattern); } catch (e) {}
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('.button,[data-card-finish],[data-menu-toggle],[data-menu-close],[data-qty-step],.pd-acc summary,.rx-box summary,[data-cd-close],[data-cd-change],[data-carousel-prev],[data-carousel-next],[data-ee-gallery-prev],[data-ee-gallery-next]')) {
        buzz(10);
      }
    }, { passive: true });
    document.addEventListener('change', function (e) {
      if (e.target.closest('[data-variant-selector],input[name="lens_variant"]')) buzz(12);
    }, { passive: true });
    if ('onscrollend' in window) {
      document.querySelectorAll('[data-cardswipe-track],[data-carousel-track],[data-ee-gallery-track],[data-heroslider-track]').forEach(function (track) {
        track.addEventListener('scrollend', function () { buzz(6); }, { passive: true });
      });
    }
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        var el = m.target;
        if (el.classList && el.classList.contains('ee-toast') && el.classList.contains('is-active')) {
          buzz(el.classList.contains('ee-toast--error') ? 45 : [15, 60, 25]);
        }
      });
    });
    function watchToast() {
      var toast = document.querySelector('.ee-toast');
      if (toast) { observer.observe(toast, { attributes: true, attributeFilter: ['class'] }); return true; }
      return false;
    }
    if (!watchToast()) {
      var bodyWatch = new MutationObserver(function () {
        if (watchToast()) bodyWatch.disconnect();
      });
      bodyWatch.observe(document.body, { childList: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ee-kaod-pack"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.body.classList.add('ee-grain-on');
    if (reduced || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    document.addEventListener('mouseover', function (e) {
      var ring = document.querySelector('.ee-cursor-ring');
      if (!ring) return;
      var media = e.target.closest('.product-card__image,.ee-gallery,.ee-carousel__media,.hero-image,.ee-portal__lens,.ee-heroslider__media');
      ring.classList.toggle('is-lens', !!media);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ee-shell"] && !Shopify.designMode) return;
  try {
    (function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var header = document.querySelector('.site-header');
  if (header && !reduced) {
    var lastY = window.scrollY, hTicking = false;
    window.addEventListener('scroll', function () {
      if (hTicking) return;
      hTicking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y > lastY + 6 && y > 160) header.classList.add('ee-hidden');
        else if (y < lastY - 4) header.classList.remove('ee-hidden');
        lastY = y;
        hTicking = false;
      });
    }, { passive: true });
  }

  var drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) {
    var itemsEl = drawer.querySelector('[data-cd-items]');
    var countEl = drawer.querySelector('[data-cd-count]');
    var totalEl = drawer.querySelector('[data-cd-total]');
    var fmt = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
    var lastSubmit = 0;
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
    function render(cart) {
      countEl.textContent = cart.item_count;
      totalEl.textContent = fmt.format(cart.total_price / 100);
      if (!cart.items.length) {
        itemsEl.innerHTML = '<div class="ee-cd__empty"><div><p class="micro">[ Bag empty ]</p><p>Your cart is empty.</p></div></div>';
        return;
      }
      var html = '';
      cart.items.forEach(function (item, i) {
        var props = '';
        if (item.properties) {
          Object.keys(item.properties).forEach(function (k) {
            if (k.charAt(0) === '_' || !item.properties[k]) return;
            var v = String(item.properties[k]);
            props += '<p class="micro">' + esc(k) + ': ' + (v.indexOf('/uploads/') > -1 ? 'file ✓' : esc(v)) + '</p>';
          });
        }
        html += '<div class="ee-cd__item">' +
          (item.image ? '<img src="' + item.image + '&width=180" alt="" loading="lazy">' : '<span></span>') +
          '<div><h3>' + esc(item.product_title) + '</h3>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="micro">' + esc(item.variant_title) + '</p>' : '') +
          props +
          '<span class="ee-cd__qty"><button type="button" data-cd-change="' + (i + 1) + '" data-cd-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button><span>' + item.quantity + '</span><button type="button" data-cd-change="' + (i + 1) + '" data-cd-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button></span></div>' +
          '<div class="ee-cd__right"><span class="ee-cd__price">' + fmt.format(item.final_line_price / 100) + '</span><button class="ee-cd__remove" type="button" data-cd-change="' + (i + 1) + '" data-cd-qty="0" aria-label="Remove">×</button></div>' +
          '</div>';
      });
      itemsEl.innerHTML = html;
    }
    function refresh() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        render(cart);
        document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
        return cart;
      });
    }
    function openDrawer() {
      refresh().then(function () {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('ee-locked');
      });
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ee-locked');
    }
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-close]')) { closeDrawer(); return; }
      var change = e.target.closest('[data-cd-change]');
      if (change) {
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: parseInt(change.dataset.cdChange, 10), quantity: parseInt(change.dataset.cdQty, 10) }) })
          .then(function () { refresh(); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href$="/cart"]');
      if (!link || link.closest('.ee-cd') || window.location.pathname === '/cart') return;
      e.preventDefault();
      openDrawer();
    });
    document.addEventListener('submit', function (e) {
      if (e.target.closest('form[action*="/cart/add"]')) lastSubmit = performance.now();
    });
    var counts = document.querySelectorAll('.cart-count');
    if (counts.length && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        if (performance.now() - lastSubmit < 6000) {
          lastSubmit = 0;
          openDrawer();
        }
      });
      counts.forEach(function (c) { mo.observe(c, { childList: true, characterData: true, subtree: true }); });
    }
  }

  var fade = document.querySelector('[data-page-fade]');
  if (fade && !reduced) {
    document.documentElement.classList.add('ee-entering');
    setTimeout(function () { document.documentElement.classList.remove('ee-entering'); }, 700);
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { fade.classList.remove('is-active'); document.documentElement.classList.remove('ee-entering'); }
    });
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var a = e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download') || a.closest('.ee-cd')) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      var url = new URL(a.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.hash) return;
      if (url.pathname.indexOf('/checkout') === 0 || url.pathname === '/cart') return;
      e.preventDefault();
      fade.classList.add('is-active');
      setTimeout(function () { window.location.href = a.href; }, 270);
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ee-studio-card"] && !Shopify.designMode) return;
  try {
    (()=>{const init=scope=>scope.querySelectorAll('[data-ee-card]').forEach(card=>{if(card.dataset.photoReady)return;card.dataset.photoReady='true';const data=card.querySelector('[data-card-photos]');if(!data)return;const photos=JSON.parse(data.textContent),link=card.querySelector('.ee-product-image'),img=link.querySelector('img');if(!img||photos.length<2)return;let index=0,blockUntil=0;const dots=[];const showIndex=i=>{index=(i+photos.length)%photos.length;img.removeAttribute('srcset');img.src=photos[index].src;img.alt=photos[index].alt;link.href=photos[index].url;link.setAttribute('aria-label',photos[index].title);card.querySelector('.ee-card-title').href=photos[index].url;const colour=card.querySelector('.ee-card-colour');if(colour)colour.textContent=photos[index].colour;card.querySelector('.ee-card-price').textContent=photos[index].price;card.querySelector('[data-card-sold-out]').hidden=photos[index].available;card.querySelector('[data-card-count]').textContent=(index+1)+' / '+photos.length;dots.forEach((d,n)=>d.setAttribute('aria-selected',n===index?'true':'false'));};const show=delta=>showIndex(index+delta);card.querySelector('[data-card-next]').addEventListener('click',()=>show(1));const media=card.querySelector('.ee-card-media');const nav=document.createElement('div');nav.className='ee-card-nav';nav.innerHTML='<button type="button" class="ee-card-nav-btn ee-card-nav-prev" aria-label="Previous colour"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 5 8 12l7 7"/></svg></button><button type="button" class="ee-card-nav-btn ee-card-nav-next" aria-label="Next colour"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m9 5 7 7-7 7"/></svg></button>';media.appendChild(nav);nav.querySelector('.ee-card-nav-prev').addEventListener('click',e=>{e.preventDefault();show(-1);});nav.querySelector('.ee-card-nav-next').addEventListener('click',e=>{e.preventDefault();show(1);});const dotWrap=document.createElement('div');dotWrap.className='ee-card-dots';dotWrap.setAttribute('role','tablist');dotWrap.setAttribute('aria-label','Colours');photos.forEach((p,n)=>{const d=document.createElement('button');d.type='button';d.className='ee-card-dot';d.setAttribute('role','tab');d.setAttribute('aria-label',p.colour||('Colour '+(n+1)));d.setAttribute('aria-selected',n===0?'true':'false');d.addEventListener('click',e=>{e.preventDefault();showIndex(n);});dotWrap.appendChild(d);dots.push(d);});media.appendChild(dotWrap);img.draggable=false;link.addEventListener('dragstart',e=>e.preventDefault());let pointer=null;link.addEventListener('pointerdown',e=>{if(!e.isPrimary||e.button!==0){pointer=null;return;}pointer={id:e.pointerId,x:e.clientX,y:e.clientY,dx:0,dy:0,horizontal:false};});link.addEventListener('pointermove',e=>{if(!pointer||pointer.id!==e.pointerId)return;pointer.dx=e.clientX-pointer.x;pointer.dy=e.clientY-pointer.y;if(Math.abs(pointer.dx)>12&&Math.abs(pointer.dx)>Math.abs(pointer.dy)*1.5){pointer.horizontal=true;e.preventDefault();try{link.setPointerCapture(e.pointerId);}catch(err){}}});link.addEventListener('pointerup',e=>{if(!pointer||pointer.id!==e.pointerId)return;const p=pointer;pointer=null;if(p.horizontal){blockUntil=Date.now()+600;if(Math.abs(p.dx)>40)show(p.dx<0?1:-1);}});link.addEventListener('pointercancel',()=>pointer=null);link.addEventListener('click',e=>{if(Date.now()<blockUntil){e.preventDefault();e.stopPropagation();}},true);link.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();show(e.key==='ArrowRight'?1:-1);}});});init(document);document.addEventListener('shopify:section:load',e=>init(e.target));})();
  } catch(e) { console.error(e); }
})();

})();
